import React, { useContext } from "react";
import Select from "react-select";
import { FilterContext } from "../../context/FilterContext";
import { GetDataContext } from "../../context/GetDataContext";
import { useSelection } from "../../context/SelectionContext";

const PollingCompanies = () => {
  const { pollingCompanies } = useContext(GetDataContext);
  const { setFilter } = useContext(FilterContext);
  const { currentSelection, setCurrentSelection } = useSelection();

  return (
    <Select
      className={"select-container"}
      classNamePrefix={"select"}
      placeholder={""}
      value={currentSelection}
      isSearchable={false}
      options={[
        { value: 0, label: "Όλες οι εταιρίες δημοσκοπήσεων" },
        ...pollingCompanies.map((item, index) => {
          return { value: item.id, label: item.name };
        }),
      ]}
      onChange={(value) => {
        setCurrentSelection(value);
        setFilter(value);
      }}
      components={{
        IndicatorSeparator: () => null,
      }}
      filterOption={(option) => option.value !== currentSelection.value}
    />
  );
};

export default PollingCompanies;
